import { useState } from 'react'

import { saveAs } from 'file-saver'
import JSZip from 'jszip'

import { apiClient, requestS3 } from '../../gateways/api'
import { useAlerts } from '../../theme/hooks/useAlerts'

export const useZipper = (fileName: string) => {
  const { errorAlert } = useAlerts()
  const [loading, setLoading] = useState(false)

  /** Download urls and save them to a .zip file. */
  const save = async (urls: string[]) => {
    const zip = new JSZip()

    try {
      setLoading(true)

      for (const url of urls) {
        const { data: result } = await apiClient({ url })
        const file = await requestS3({
          url: result.downloadData.url,
          responseType: 'blob',
        })

        zip.file(result.databaseData.naam, file.arrayBuffer())
      }

      const content = await zip.generateAsync({ type: 'blob' })

      saveAs(content, `${fileName}.zip`)
    } catch (error: any) {
      errorAlert('Fout bij openen bestanden', error)
    } finally {
      setLoading(false)
    }
  }

  return { loading, save }
}
